import React, {use, useEffect, useState} from "react";
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';

const AcaoSocial = () => {

    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);

  const [doadorForm, setDoadorForm] = useState({
    dNome: '',
    dEmail: '',
    dTelefone: '',
    dTipoDoacao: '',
    dDescricao: '',
    dDataCadastro: new Date().toISOString().split('T')[0], // Data atual no formato YYYY-MM-DD
    dCodigoGUID: crypto.randomUUID() // Gerar um GUID único para o doador
  });

  const [instituicaoForm, setInstituicaoForm] = useState({
    iNomeInstituicao: '',
    iEmail: '',
    iTelefone: '',
    iEndereco: '',
    iRepresentante: '',
    iDataCadastro: new Date().toISOString().split('T')[0], // Data atual no formato YYYY-MM-DD
    iCodigoGUID: crypto.randomUUID() // Gerar um GUID único para a instituição
  });

  const handleDoadorChange = (e) => {
    const { name, value } = e.target;
    setDoadorForm({ ...doadorForm, [name]: value });
  };

  const handleInstituicaoChange = (e) => {
    const { name, value } = e.target;
    setInstituicaoForm({ ...instituicaoForm, [name]: value });
  };

  const handleDoadorSubmit = (e) => {
    e.preventDefault();
    setIsLoadingMOD(true);
    axios
    .post(process.env.REACT_APP_API_URL +
        '/routes.php?metodo=novoDoador'
        , doadorForm
        ,{ headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } })
    .then(response => {
      //console.log('Doação registrada:', response.data);
      alert('Obrigado por sua doação! Entraremos em contato em breve.');
      setDoadorForm({
        dNome: '',
        dEmail: '',
        dTelefone: '',
        dTipoDoacao: '',
        dDescricao: ''
      });
      setIsLoadingMOD(false);
    })
    .catch(error => {
      console.error('Erro ao registrar doação:', error);
      alert('Ocorreu um erro ao registrar sua doação. Por favor, tente novamente mais tarde.');
      setIsLoadingMOD(false);
    });
  };

  const handleInstituicaoSubmit = (e) => {
    e.preventDefault();
    setIsLoadingMOD(true);
    axios
    .post(process.env.REACT_APP_API_URL +
        '/routes.php?metodo=novaInstituicao'
        , instituicaoForm
        ,{ headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } })
    .then(response => {
      //console.log('Instituição registrada:', response.data);
      alert('Sua instituição foi registrada com sucesso! Entraremos em contato em breve.');
      setInstituicaoForm({
        iNomeInstituicao: '',
        iEmail: '',
        iTelefone: '',
        iEndereco: '',
        iRepresentante: ''
      });
      setIsLoadingMOD(false);
    })
    .catch(error => {
      console.error('Erro ao registrar instituição:', error);
      alert('Ocorreu um erro ao registrar sua instituição. Por favor, tente novamente mais tarde.');
      setIsLoadingMOD(false);
    });
  };

  //salvar log de navegação
  useEffect(() => {
    
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Ação Social",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  const telefone = '5511920049313';
  const mensagem = encodeURIComponent('Olá! Gostaria de mais informações sobre Ação Social Brasil Extremos.');
  const linkWhatsApp = `https://wa.me/${telefone}?text=${mensagem}`;

  return (
    <div style={{ paddingBottom: '80px' }}>
        <main>
          <div>
              <div className='headerMain'>
              <h2>Ação Social MGBE</h2>
              <p className="hero-subtitle">Transformando vidas através da solidariedade e comprometimento</p>
            </div>
          </div>
            <div className='d-flex w100 flex-column flex-md-row justify-content-center align-items-start gap-4'>
            {/* Missão Social */}
            <div className='boxCenter'>
              <h2>Nossa Missão Social</h2>
              <p className="mt1">
                O Moto Grupo Brasil Extremos (MGBE) acredita que o verdadeiro significado de uma comunidade
                vai além das trilhas e estradas. A ação social é o coração da nossa filosofia, refletindo
                nosso compromisso em retribuir à sociedade e fazer a diferença na vida de quem mais precisa.
              </p>
              <p>
                Através de nossas ações, promovemos dignidade, esperança e transformação social,
                levando alimentos, equipamentos, fraldas e demais itens essenciais para famílias
                e instituições que enfrentam dificuldades.
              </p>
            </div>
                {/* O que Fazemos */}
            <div className='boxCenter'>
              <h2>O que Fazemos</h2>
              <div className="mt1">
                <div className="mt1">
                  <h3>Distribuição de Alimentos</h3>
                  <p>Entregamos alimentos e mantimentos essenciais para comunidades carentes.</p>
                </div>
                <div className="mt1">
                  <h3>Doações de Fraldas</h3>
                  <p>Apoiamos famílias com doações de fraldas e itens de higiene infantil e adulto.</p>
                </div>
                <div className="mt1">
                  <h3>Equipamentos Eletrônicos</h3>
                  <p>Fornecemos computadores, tablets e outros equipamentos para educação digital.</p>
                </div>
                <div className="mt1">
                  <h3>Visitas Solidárias</h3>
                  <p>Realizamos visitas e ações diretas nas instituições parceiras.</p>
                </div>
                <div className="mt1">
                  <h3>Rifas e Bingos Solidários</h3>
                  <p>Realizamos rifas e bingos para arrecadar fundos e apoiar nossas ações sociais.</p>
                </div>
              </div>
            </div>
          
            <div className='boxCenter'>
              <h2>Nossos Valores</h2>
              <div className="mt1">
                <div className="mt1">
                  <h4>Solidariedade</h4>
                  <p>Acreditamos na importância de estar junto aos que precisam.</p>
                </div>
                <div className="mt1">
                  <h4>Responsabilidade</h4>
                  <p>Cumprimos nossos compromissos com integridade e transparência.</p>
                </div>
                <div className="mt1">
                  <h4>Comunidade</h4>
                  <p>Nos unimos em torno de um propósito maior que nos transcende.</p>
                </div>
                <div className="mt1">
                  <h4>Respeito</h4>
                  <p>Reconhecemos a dignidade de cada pessoa que ajudamos.</p>
                </div>
              </div>
            </div>

            {/* Formulários de Doação e Cadastro de Instituições */}
            <div className='boxCenter'>
              <h2>Participe da Nossa Ação Social</h2>
                <p>
                    Se você deseja contribuir com nossa ação social, seja como doador ou instituição beneficiada, 
                    preencha os formulários abaixo. Sua colaboração é fundamental para continuarmos transformando 
                    vidas e promovendo solidariedade.
                </p>
              
              <div className="mt2">
                {/* Formulário de Doação */}
                <div>
                  <form onSubmit={handleDoadorSubmit}>
                    <p><h2>Desejo Fazer uma Doação:</h2></p>
                    <div className="w100 text-align-left mt1">
                      <label><h3>Seu Nome *</h3></label>
                      <input type="text"
                        id="dNome"
                        name="dNome"
                        value={doadorForm.dNome}
                        onChange={handleDoadorChange}
                        required
                        placeholder="Digite seu nome"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label><h3>E-mail *</h3></label>
                      <input type="email"
                        id="dEmail"
                        name="dEmail"
                        value={doadorForm.dEmail}
                        onChange={handleDoadorChange}
                        required
                        placeholder="seu@email.com"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label><h3>Telefone *</h3></label>
                      <input type="tel"
                        id="dTelefone"
                        name="dTelefone"
                        value={doadorForm.dTelefone}
                        onChange={handleDoadorChange}
                        required
                        placeholder="(XX) XXXXX-XXXX"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label><h3>Tipo de Doação *</h3></label>
                      <select
                        id="dTipoDoacao"
                        name="dTipoDoacao"
                        value={doadorForm.dTipoDoacao}
                        onChange={handleDoadorChange}
                        required
                        className="p1 bgGray fs12 w100"
                      >
                        <option value="">Selecione uma opção</option>
                        <option value="alimentos">Alimentos</option>
                        <option value="fraldas">Fraldas</option>
                        <option value="eletronico">Equipamentos Eletrônicos</option>
                        <option value="higiene">Itens de Higiene</option>
                        <option value="outro">Outro</option>
                      </select>
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label><h3>Descrição da Doação</h3></label>
                      <textarea
                        id="dDescricao"
                        name="dDescricao"
                        value={doadorForm.dDescricao}
                        onChange={handleDoadorChange}
                        placeholder="Descreva o que você pretende doar"
                        rows="4"
                        className="p1 bgGray fs12 w100"
                      ></textarea>
                    </div>
                    {isLoadingMOD ? (
                        <div className="d-flex flex-column w100 text-align-center">
                        <CircularProgress />
                        <span>Aguarde...</span>
                        </div>
                    ) : 
                    <div className="w100 text-align-right mt1">
                        <button type="submit" className="buttonModalPadrao p1">Registrar Doação</button>
                    </div>}
                  </form>
                </div>

                {/* Formulário de Cadastro de Instituições */}
                <div className="mt3">
                  <form onSubmit={handleInstituicaoSubmit}>
                    <h2>Cadastro de Instituições</h2>
                    <p>
                        <h3>Sua instituição pode se cadastrar para receber doações e visitas sociais do MGBE.</h3>
                    </p>

                    <div className="w100 text-align-left mt1">
                      <label htmlFor="iNomeInstituicao">Nome da Instituição *</label>
                      <input
                        type="text"
                        id="iNomeInstituicao"
                        name="iNomeInstituicao"
                        value={instituicaoForm.iNomeInstituicao}
                        onChange={handleInstituicaoChange}
                        required
                        placeholder="Nome completo"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label htmlFor="iRepresentante">Representante *</label>
                      <input
                        type="text"
                        id="iRepresentante"
                        name="iRepresentante"
                        value={instituicaoForm.iRepresentante}
                        onChange={handleInstituicaoChange}
                        required
                        placeholder="Nome do representante"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label htmlFor="iEmail">E-mail *</label>
                      <input
                        type="email"
                        id="iEmail"
                        name="iEmail"
                        value={instituicaoForm.iEmail}
                        onChange={handleInstituicaoChange}
                        required
                        placeholder="email@instituicao.com"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label htmlFor="iTelefone">Telefone *</label>
                      <input
                        type="tel"
                        id="iTelefone"
                        name="iTelefone"
                        value={instituicaoForm.iTelefone}
                        onChange={handleInstituicaoChange}
                        required
                        placeholder="(XX) XXXXX-XXXX"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>

                    <div className="w100 text-align-left mt1">
                      <label htmlFor="iEndereco">Endereço *</label>
                      <input
                        type="text"
                        id="iEndereco"
                        name="iEndereco"
                        value={instituicaoForm.iEndereco}
                        onChange={handleInstituicaoChange}
                        required
                        placeholder="Rua, número, bairro, cidade"
                        className="p1 bgGray fs12 w100"
                      />
                    </div>
                    {isLoadingMOD ? (
                        <div className="d-flex flex-column w100 text-align-center">
                        <CircularProgress />
                        <span>Aguarde...</span>
                        </div>
                    ) : 
                    <div className="w100 text-align-right mt1">
                        <button type="submit" className="buttonModalPadrao p1">Registrar Instituição</button>
                    </div>}
                  </form>
                </div>
              </div>
            </div>

            <div className='boxCenter'>
            <div>
                <p><strong>PIX PARA DOAÇÕES:</strong></p>
                <p><strong>CNPJ:</strong> 51.422.528/0001-90</p>
                <p><strong>NOME:</strong> ASSOC. DE MOTOC. BRASIL EXTREMOS MOTO GRUPO</p>
            </div>
            <div className="mt2">
              <h2>Entre em Contato</h2>
                <p>Tem dúvidas ou gostaria de colaborar conosco de outra forma?</p>
                <p>Entre em contato com nossa direção de ação social. </p>
              <div className="contato-info">
                <p><strong>E-mail:</strong> <a href="mailto:contato@brasilextremos.com.br" style={{ color: 'inherit', textDecoration: 'none', fontStyle: 'italic', fontSize: '0.9em' }} >contato@brasilextremos.com.br</a></p>
                <br />
                <a href={linkWhatsApp} target="_blank" rel="noopener noreferrer" className="buttonModalPadrao p1 mt1" style={{ textDecoration: 'none', display: 'inline-block' }}>
                                Enviar Mensagem pelo WhatsApp {<WhatsApp style={{ marginLeft: '0.4em', height: '1em', marginBottom: '-5px' }} />}
                              </a>
          </div>
          </div>
        </div>

      </div>
      </main>
    </div>
  );
};

export default AcaoSocial;
